export default {
    fr: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        },
        dateOnly: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long'
        }
    }
}
